import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'antd';
import { Footer , Header} from '../index';
import './prepa.css'


const items = [
  {
    key: '1',
    label:' Préparatoire intégré en informatique', 
    children: 
          <div>
                <p>    <h6>DESCRIPTION</h6> 
                Préparatoire intégré en informatique : MPI (Math Physique Informatique)<br/>
                Depuis l’année universitaire 2020-2021, le département informatique  intègre 
                un cycle préparatoire intégré. L’objectif des deux années de préparation intégrée 
                au cycle d’ingénieur de l’ISIMM est d’acquérir principalement un socle de 
                connaissances solides, sur lequel s’appuiera ensuite le cycle ingénieur.
                 Le programme de ces deux années intègre des cours bien poussés en mathématique,
                  électronique, mais il s’en distingue aussi grâce à des enseignements plus 
                  concrets en informatique fondamentale et appliqué aux différents contextes  .<br/>
 
                  Un cycle préparatoire intégré en science de l'informatique dure 2 ans au cours duquel un seul redoublement est permis. 
                  L’admission à ce cycle préparatoire intégré se fait par l’orientation de nouveaux bacheliers.
                                                              
                Le cycle de formation d’ingénieurs avec le cycle préparatoire intégré sont gérés par le département génie informatique .
                Ce département offre une formation d’ingénieurs en Informatique et génie logiciel. <br/>
                    <span className='sous-title'>Plan d'études : </span>
                    <Link to='/Prépa'><span >Cliquer ici</span></Link> </p>           </div>
,
  },
 
  
];
    function Prepa() {
        const onChange = (key) => {
            console.log(key);
        };
    return (
        <>
        <Header/>

         <div className='containerPrep'>
        <div className='bgprep'>  </div>
        <div className='ligne'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-287px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'55px'}}className="container-fluid text-white text-center ">Cycle préparatoire</h1>
          <p ><Link className='linkIng' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkIng'
            to="/"> Formation </Link>  <span>{'>'}</span> <Link className='linkIng'
            to="/Prépa">Cycle préparatoire</Link> </p></div>
      </div>

          <div className='Collapse'>
          <div className='ligne1'>  </div>

              <Collapse   accordion   destroyInactivePanel={false} style={{ borderRadius: 0 , minWidth: '100%' , minHeight: '200px' }} size="large" items={items} defaultActiveKey={['1' ]} onChange={onChange} />
          </div>
        
        <Footer/>
        </>

    ) ;
}

export default Prepa;
